interface GetGigIDsFromAsPath {
  channelId: string
  webcastId: string
}
function getGigIDsFromAsPath (asPath = ''): GetGigIDsFromAsPath {

  // Make sure we're not including the search params
  const [ url ] = asPath.split('?')

  if (typeof url !== 'string') return {
    channelId: '',
    webcastId: ''
  }

    // If query isn't yet populated, split values from asPath
  const [ channelId = '', webcastId = '' ] = url.replace(/^\//, '').split('/')
  
  return {
    channelId,
    webcastId
  }

}

export default getGigIDsFromAsPath
